import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { tap, shareReplay } from 'rxjs/operators';

import * as moment from 'moment';
import jwtDecode from 'jwt-decode';
import { Router } from '@angular/router';
import { CartService } from '../modules/views/cart/cart.service';

export interface JWTPayload {
  token_type: string,
  exp: number,
  jti: string,
  user_id: string
}

export interface User {
  username: string,
  password: string
}

@Injectable()
export class AuthService {
  
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private router: Router,
    private cartService: CartService
  ) { }

  private setSession(authResult: any) {
    const payload = <JWTPayload> jwtDecode(authResult.access);
    const expiresAt = moment.unix(payload.exp);

    localStorage.setItem('tk', authResult.access);
    localStorage.setItem('tk_exp', JSON.stringify(expiresAt.valueOf()));
    localStorage.setItem('uid', authResult.user_id)
    localStorage.setItem('url', authResult.user_role)
    localStorage.setItem('change_pass', authResult.change_pass)
  }

  get token() {
    return localStorage.getItem('tk');
  }

  get tokenExpiration() {
    return localStorage.getItem('tk_exp');
  }

  login(username: string, password: string) {
    return this.http.post(this.apiUrl.concat('/login/'), { username, password }).
      pipe(
        tap((response: any) => {
          this.setSession(response);
          this.router.navigate(['']);
        }),
        shareReplay(),
      );
  }

  logout() {    
    this.router.navigate(['login']);
    
    localStorage.removeItem('tk');
    localStorage.removeItem('tk_exp');
    localStorage.removeItem('uid');
    localStorage.removeItem('url');
    this.cartService.cartLoaded = false;
  }

  tokenExpired() {
    if (this.tokenExpiration) {
      return (Math.floor((new Date).getTime())) >= parseInt(this.tokenExpiration);
    }
    return true;
  }
  
  isLoggedIn() {
    if (!!this.token && !this.tokenExpired()) {
      return true;
    }
    return false;
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }
}
